'use strict';

export { default as NotFoundContainer } from './NotFoundContainer.jsx';
